module.exports = __webpack_public_path__ + "4e5da1accda6a9fb5478bb6b4c22d728.svg";